import { cva } from '@repo/pandacss/css';
import { styled } from '@repo/pandacss/jsx';

const linkRecipe = cva({
  base: {
    textStyle: 'inherit',
    color: 'secondary.main',
  },
  variants: {
    underline: {
      none: {
        textDecoration: 'none',
        _hover: {
          textDecoration: 'none',
        },
      },
      hover: {
        textDecoration: 'none',
        _hover: {
          textDecoration: 'underline',
        },
      },
      always: {
        textDecoration: 'underline',
        _hover: {
          textDecorationColor: '[inherit]',
        },
      },
    },
  },
  defaultVariants: {
    underline: 'always',
  },
});

export const Link = styled('a', linkRecipe);

Link.displayName = 'Link';
